import { render } from "./newDevis.vue?vue&type=template&id=24c12474&scoped=true"
import script from "./newDevis.vue?vue&type=script&lang=js"
export * from "./newDevis.vue?vue&type=script&lang=js"

import "./newDevis.vue?vue&type=style&index=0&id=24c12474&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c12474"]])

export default __exports__